export default __webpack_public_path__ + "static/media/ic_user.85e760a8.svg";